<template>
    <div class="picker nameFill"
        :class="mustFlag">
        <h6><span></span>申请人姓名</h6>
        <div class="text">
            <input
                type="text"
                placeholder="请输入申请人姓名"
                maxlength="5"
                v-model.trim="name"
                @change="getMess"
            >

        </div>
    </div>
</template>

<script>
    export default {
        props: ["mustFlag"],
        data () {
            return {
                name : ''
            }
        },
        methods:{
            getMess(){
                this.$emit('transMess' , ['name' , this.name])
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/NameFill/NameFill.vue